import TemplatePreviewChart from './template-preview-chart';


export default TemplatePreviewChart;